import React from 'react';
import './style.scss';
import { useSelector, useDispatch } from 'react-redux';
import Action from './action';

import Modal from '../../../components/Modal';

const GlobalModalBox: React.FC = () => {
    const { onSure, title, onCancel, onClose, content, show, showClose, sureText, cancelText, extraClass } = useSelector((state: any) => state.GlobalModalBox);
    const dispatch = useDispatch();
    const handleSureClick = () => {
        let cbTag = true;
        if (onSure && typeof onSure === 'function') {
            cbTag = onSure()
            if (typeof cbTag === 'boolean' && !cbTag) {
                return;
            }
        }
        dispatch({
            type: Action.UPDATE_GLOBAL_MODAL,
            playload: {
                show: false
            }
        })
    }

    const handleCancelClick = () => {
        onCancel && onCancel();
        dispatch({
            type: Action.UPDATE_GLOBAL_MODAL,
            playload: {
                show: false
            }
        })
    }

    const handleCloseClick = () => {
        onClose && onClose();
        dispatch({
            type: Action.UPDATE_GLOBAL_MODAL,
            playload: {
                show: false
            }
        })
    }

    return (
        <>
            { show ?
                <Modal extraClass={extraClass} sureText={sureText} showClose={showClose} cancelText={cancelText} onSure={handleSureClick} onCancel={handleCancelClick} onClose={handleCloseClick} title={title}>
                    {content}
                </Modal> :
                null
            }
        </>
    )
}

export default GlobalModalBox;
